
export { BasicNewsManager } from "/builds/benzinga/fusion/libs/data/manager/basic-news/src/manager.ts"